import * as React from 'react'
import * as z from "zod";
import { Outlet, createRootRoute } from '@tanstack/react-router'
import App from '@/App'
import { AuthStoreState } from '@/Stores/AuthStore'

interface MyRouterContext {
  // The ReturnType of your useAuth hook or the value of your AuthContext
  authStore: AuthStoreState
}
const rootSearchSchema = z.object({
  redirect: z.string().optional().catch(''),
})

export const Route = createRootRoute({
  component: RootComponent,
  validateSearch: (search) => rootSearchSchema.parse(search),
})

function RootComponent() {
  return (
    <React.Fragment>
      <App />
    </React.Fragment>
  )
}
